import React, { useEffect } from "react";
import {
  FiSearch,
  FiHome,
  FiLayers,
  FiDollarSign,
  FiUsers,
  FiFileText,
  FiShoppingCart,
  FiSettings,
  FiHelpCircle,
  FiUser,
  FiLogOut,
} from "react-icons/fi";
import logo from "../assets/logo.png";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { FaCashRegister, FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/reducers/authSlice";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedMenu = location.pathname.split("/")[1];
  const { userDetails } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="min-h-screen h-screen overflow-auto rounded-r flex flex-col bg-primary text-white w-16 sm:w-20 lg:w-64 transition-all duration-300 ease-in-out">
      <div className="flex items-center justify-start p-2 lg:p-4">
        <img src={logo} alt="Logo" className="hidden lg:block" width={100} />
        <span className="text-lg font-bold py-2 hidden lg:block">
          Revenue Pro Planner
        </span>
      </div>

      <nav className="flex-grow mt-6">
        <ul className="space-y-2 px-2 lg:px-4">
          <li>
            <Link
              to={"/lead-calculator"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "lead-calculator" ? "bg-gray-800" : ""
              }`}
            >
              <FiHome className="text-xl" />
              <span className="ml-3 hidden lg:block">Lead Calculator</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/start-tracker"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "start-tracker" ? "bg-gray-800" : ""
              }`}
            >
              <FiLayers className="text-xl" />
              <span className="ml-3 hidden lg:block">Start Tracker</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/tuition-income"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "tuition-income" ? "bg-gray-800" : ""
              }`}
            >
              <FiDollarSign className="text-xl" />
              <span className="ml-3 hidden lg:block">Tuition Income</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/student-drop"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "drop-out" ? "bg-gray-800" : ""
              }`}
            >
              <FiUsers className="text-xl" />
              <span className="ml-3 hidden lg:block">Students Drop</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/clinic-sales"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "clinic-sales" ? "bg-gray-800" : ""
              }`}
            >
              <FiShoppingCart className="text-xl" />
              <span className="ml-3 hidden lg:block">Clinic Sales</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/profit-loss"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "profit-loss" ? "bg-gray-800" : ""
              }`}
            >
              <FiFileText className="text-xl" />
              <span className="ml-3 hidden lg:block">Profit & Loss</span>
            </Link>
          </li>
        </ul>
      </nav>

      {/* Footer Section */}
      <div className="px-2 lg:px-4">
        <div className="border-t border-gray-700 py-4">
          <div className="flex items-center ml-3 space-x-2 lg:space-x-4">
          <div className="">
              <FiUser className="text-xl" />
            </div>
            <div className="hidden lg:block">
              <p className="text-sm">{userDetails?.name}</p>
              <p className="text-xs text-gray-400 w-48 truncate cursor-pointer">
                {userDetails?.email ?? "-"}
              </p>
            </div>
           
          </div>
        </div>

        <div className="space-y-2 mb-4">
          <Link
            to={"/settings"}
            className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
              selectedMenu === "settings" ? "bg-gray-800" : ""
            }`}
          >
            <FiHelpCircle className="text-xl" />
            <span className="ml-3 hidden lg:block">Settings</span>
          </Link>

          <Link
            to={"/checkout"}
            className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
              selectedMenu === "checkout" ? "bg-gray-800" : ""
            }`}
          >
            <FaCashRegister className="text-xl" />
            <span className="ml-3 hidden lg:block">Billing</span>
          </Link>

          <button
            onClick={handleLogout}
            className="flex items-center px-2 lg:px-4 py-2 hover:bg-white rounded-md text-red-600 w-full bg-red-100 font-bold"
          >
            <FiLogOut className="text-xl" />
            <span className="ml-3 hidden lg:block">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
